import { GET } from "../../../helpers/restFunction";

const GetAllTickets = async (userId: String) => {
  const path = `/cad/${userId}/cad_support`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
export default GetAllTickets;
